module.exports = "/wwwroot/img/minisite_front_page.png?ver=7e392b04";